export const CONTAINER_ANIMATION_PROPS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 }
}

export const CONTENT_ANIMATION_PROPS = {
  initial: {
    opacity: 0,
    scale: 0.5,
    translateX: '-50%',
    translateY: '-50%'
  },
  animate: { opacity: 1, scale: 1 },
  exit: {
    opacity: 0,
    scale: 0.5,
    transition: {
      duration: 0.3
    }
  }
}
